import axios from 'axios';
import { message } from 'antd';
import md5 from 'md5';
import { version } from '../config';
import { getUser } from './util';

// 生成随机字符串
function randomText() {
    const text = 'qwertyuiopasdfghjklzxcvbnm1234567890'.split('');
    let result = '';
    let i = 0;
    while (i < 12) {
        result += text[Math.floor(Math.random() * 12)];
        i++;
    }
    return result;
}
// 生成签名
function createSign(nonceStr, token) {
    const result = md5(token + nonceStr);
    return result.toUpperCase();
}

// 错误处理
function catchFunc(error) {
    if (error instanceof Error) { // 处理3~5错误
        message.error('网络错误');
    } else if (typeof (error) == 'string') { // 处理业务错误
        message.error(error);
    } else if (typeof (error) == 'object' && error.msg) { // 处理其他错误
        message.error(error.msg);
    } else {
        return error;
        // message.error('请求失败');
    }
    return error;
}
// 成功处理
function successFunc(res) {
    if (res.status != 200 || !res.data) {
        return Promise.reject({ msg: '请求错误' });
    };
    if (res.data.code == 4001) {
        setTimeout(() => {
            sessionStorage.clear();
            localStorage.clear();
            // window.location.href = `/`;
        }, 200);
        return Promise.reject(res.data);
    }
    if (res.data.code && res.data.code != 200) {
        return Promise.reject(res.data);
    }
    return res.data || {};
}
// 创建headers
function createHeader(token) {
    const headers = {
        'Content-Type': 'application/json'
    };
    if (!token) {
        token = (getUser() || {}).token;
    }
    if (token != ' ') {
        headers['Access-Token'] = token;
        const nonceStr = randomText();
        headers['nonceStr'] = nonceStr;
        headers['sign'] = createSign(nonceStr, token);
    }
    return headers;
}

// 整理数据为string 因为后端只能接受string
function createData(data) {

    if (data == null || data == undefined) return;
    if (Array.isArray(data)) {
        return data.map(item => createData(item));
    } else if (typeof (data) == 'object') {
        const result = {};
        data = Object.keys(data).forEach(key => {
            result[key] = createData(data[key]);
        });
        return result;
    } else {
        return `${data}`;
    }
}
// 整理get参数
function makeQuery(data) {
    if (!data) return '';
    return `?${Object.keys(data).reduce((pre, key) => {
        return pre.concat([`${key}=${encodeURIComponent(data[key])}`]);
    }, []).join('&')}`;
}
function init () {
  window.$http = {
    // 通用post
    post: function (url, data, token) {
      return axios({
          method: 'post',
          url,
          data: createData(data),
          headers: createHeader(token),
      }).then(successFunc).catch(catchFunc);
    },
    // 通用get
    get: function (url, data, token) {
      return axios({
          method: 'get',
          url: `${url}${makeQuery(data)}`,
          data,
          headers: createHeader(token),
      }).then(successFunc).catch(catchFunc);
    },
    // 通用put
    put: function (url, data, token) {
      return axios({
          method: 'put',
          url,
          data,
          headers: createHeader(token),
      }).then(successFunc).catch(catchFunc);
    },
    // 不做任何处理的post
    noSuccPost: function (url, data, token) {
      return axios({
          method: 'post',
          url,
          data,
          headers: createHeader(token),
      }).then(successFunc).catch(catchFunc);
    },
    // 不做任何处理不带header的post
    noSuccHeaderPost: function (url, data) {
      return axios({
          method: 'post',
          url,
          data,
      }).then(successFunc).catch(catchFunc);
    },
    downloadPost: function (url, params, token) {
      return axios({
          method: 'post',
          url:url,
          data:params,
          responseType:'blob',        
          headers: createHeader(token),
      })
    },
    downloadGet: function (url, params, token) {
      return axios({
          method: 'get',
          url:url,
          data:params,
          responseType:'blob',        
          headers: createHeader(token),
      })
    }
  }
}

export default init;




// WEBPACK FOOTER //
// ./src/utils/http.js